/**
 * This Software is the property of dotfly and is protected
 * by copyright law - it is NOT Freeware.
 *
 * Any unauthorized use of this software without a valid license key
 * is a violation of the license agreement and will be prosecuted by
 * civil and criminal law.
 *
 * @category   Responsive Accordion
 * @author     Franziska Radek <franziska.radek@dotfly.de>
 * @license    http://www.dotfly.de Commercial
 * @link       http://www.dotfly.de
 */

const ResponsiveAccordion = () => {
    let _oAccordion = document.querySelectorAll('.c-accordion');

    function handlePanelClick(e){
        showPanel(e.currentTarget);
    }

    function showPanel(panel){
        let _oSelf = panel;
        let _oCurrentPanel = _oSelf.classList.contains('c-accordion--active');
        let _oContentPanel = _oSelf.nextElementSibling;
        let _oContentWrapPanel = _oContentPanel.firstElementChild;
        let _iContentHeight = _oContentWrapPanel.offsetHeight;

        // = Aria
        let _bIsAriaExp = _oSelf.getAttribute('aria-expanded');
        let _bNewAriaExp = (_bIsAriaExp === 'false') ? 'true' : 'false';

        _oSelf.setAttribute('aria-expanded', _bNewAriaExp);

        if(_oCurrentPanel) {
            _oSelf.classList.remove('c-accordion--active');
            _oContentPanel.style.height = 0;
            _oContentPanel.setAttribute('aria-hidden', 'true');
        }else {
            _oSelf.classList.add('c-accordion--active');
            _oContentPanel.style.height = _iContentHeight + 'px';
            _oContentPanel.setAttribute('aria-hidden', 'false');
        }
    }

    if(_oAccordion) {
        _oAccordion.forEach(function (accordionModule) {
            let _aAllPanelElems = accordionModule.querySelectorAll('.js-acc-trigger');
            _aAllPanelElems.forEach(function (panelitem) {
                panelitem.addEventListener('click', handlePanelClick);
            });
        });
    }
};

ResponsiveAccordion();
